import { render, staticRenderFns } from "./employeesList.vue?vue&type=template&id=ffdf24a6&scoped=true&lang=html"
import script from "./employeesList.vue?vue&type=script&lang=js"
export * from "./employeesList.vue?vue&type=script&lang=js"
import style0 from "./employeesList.vue?vue&type=style&index=0&id=ffdf24a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdf24a6",
  null
  
)

export default component.exports